import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function acceptCanGoOutAloneAuthorization(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.acceptGoOutAloneAuthorization.url, { id }))
    .post()
}
